module.exports = __webpack_public_path__ + "static/media/3DPPA21.daa9831f.jpg";